<template>
  <div class="vr360-output-link"
       :class="{'js-copied': isCopied}">
    <p class="vr360-head-h4 vr360-text-gray-2 vr360-output-link__title">Your link to stream</p>
    <div class="vr360-output-link__cont">
      <output class="vr360-text-reg vr360-output-link__cont__output" ref="outLink">{{ currentStream.link_rtmp }}</output>
      <button type="button" class="vr360-output-link__cont__copy"
                  v-clipboard:copy="currentStream.link_rtmp"
                  v-clipboard:success="handleCopyStatusSuccess"
                  v-clipboard:error="handleCopyStatusFalse">
        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 4.88305H4.63635V21.0001H17V4.88305Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M14.3334 0.999998H1V18.1427" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Output",
  data() {
    return {
      isCopied: false
    };
  },
  methods: {
    ...mapActions({
      showNotification: "showNotification"
    }),
    handleCopyStatusSuccess() {
      document.execCommand("selectall", null, false);

      this.isCopied = true;

      if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(this.$refs.outLink);
        range.select();
      } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(this.$refs.outLink);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      this.showNotification({
        type: "success",
        message: "Copied!"
      });
    },
    handleCopyStatusFalse() {
      this.showNotification({
        type: "error",
        message: "Press CTRL+C to copy."
      });
    }
  },
  computed: {
    ...mapGetters({
      currentStream: "stream/currentStream"
    })
  }
};
</script>

<style lang="scss">
</style>